// Protected Route wrapper for authenticated pages
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  // If user data was passed from AuthCallback, we're authenticated
  if (location.state?.user) {
    return children;
  }

  // Show loading while checking auth
  if (loading) {
    return (
      <div className="min-h-screen bg-[#1E1E1E] flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-12 h-12 text-[#F7A600] animate-spin mx-auto mb-4" />
          <p className="text-white text-lg">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/proview/login" replace state={{ from: location }} />;
  }

  return children;
};

export default ProtectedRoute;
